module.exports = __webpack_public_path__ + "img/flow.ee48b0c6.png";